import {Avatar} from 'antd'
import {getFullAvatarUrl} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import React, {useContext} from 'react'
import {IoHome} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {FlexCol} from 'views/AppLocals/Templates/ItemTemplate'
import {PiExam} from "react-icons/pi";

const ActionButtons = ({item}) => {
    const {isLg} = useContext(LayoutContext)
    if (!isLg) return null
    return (
    <div className="flex flex-row space-x-1">
        <Link
            to={getLinkToDetail(item)}
            className="w-10 h-10 rounded-full flex flex-center background-100 hover:bg-primary-100 text-color-500 hover:text-primary">
            <IoHome className="Icon"/>
        </Link>
    </div>
    )
}

const ExaminationSettingHeader = ({ examination }) => {
  const { isSm } = useContext(LayoutContext)

  const item = examination || {}

  const avatar = getFullAvatarUrl(item)

  if (_.isEmpty(item)) return null

  return (
    <div className="py-0 md:py-3 w-full container mx-auto">
      <div className="flex items-center">
        <Avatar
            size={isSm ? 65 : 80}
            src={avatar}
            icon={<PiExam className="text-color-300"/>}
            className="object-cover rounded-lg border border-color-50 background-200"
        />

        <div className="flex flex-col px-3">
          <Link
              className="font-bold text-sm md:text-xl hover:text-primary no-underline"
              title={getTitle(item)}
              to={getLinkToDetail(item)}>
            {getTitle(item)}
          </Link>
        </div>
        <FlexCol />
        <ActionButtons {...{ item }} />
      </div>
    </div>
  )
}

export default ExaminationSettingHeader
